import React from 'react';
import ReactDOM from 'react-dom';
import curi from '@curi/core';
import createScrollSideEffect from '@curi/side-effect-scroll';
import Browser from '@hickory/browser';

import { CuriProvider } from '@curi/react';
import mixpanel from 'mixpanel-browser';
import MixpanelProvider from 'react-mixpanel';
import TagManager from 'react-gtm-module';
import { gtmEvent } from './services/google-tag-manager';
import App from './containers/App';
import createRoutes from './routes';
import registerServiceWorker from './registerServiceWorker';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
  dataLayer: {},
};

if (process.env.NODE_ENV !== 'production') {
  tagManagerArgs['auth'] = 'cIbY-s0H-cms-MiYD9moEg';
  tagManagerArgs['preview'] = 'env-5';
}

const scrollTo = createScrollSideEffect();
const history = Browser();
const router = curi(history, createRoutes(), {
  sideEffects: [{ effect: scrollTo, after: true }]
});

let root = document.getElementById('root');

const debug = process.env.NODE_ENV !== 'production';
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug });
TagManager.initialize(tagManagerArgs);

gtmEvent({ action: 'optimize.activate' });

router.respond(() => {
  ReactDOM.hydrate((
    <CuriProvider router={router}>
      {({ response }) => {
        return (
          <MixpanelProvider mixpanel={mixpanel}>
            <App response={response} />
          </MixpanelProvider>
        );
      }}
    </CuriProvider>
  ), root);
});

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/app.browser.js